const ErrorExamplePage = () => {
  throw Error("Error cause will appear here");
};

export default ErrorExamplePage;
